const findClosestLessThanOrEqual = (value: number, items: number[]): number | null => {
  let closest: number | null = null;

  items.forEach(item => {
    if (item <= value && (closest === null || value - item < value - closest)) {
      closest = item;
    }
  });

  return closest;
};

export default findClosestLessThanOrEqual;